<template>
  <section class="insights-page">
    <header class="hero">
      <div>
        <p class="eyebrow">Route Two</p>
        <h1>Insights Board</h1>
        <p class="hero__copy">
          This page proves the Vue2 child app can manage its own internal navigation while mounted inside qiankun.
        </p>
      </div>
    </header>

    <section class="grid">
      <article class="card" v-for="card in cards" :key="card.title">
        <p class="card__kicker">{{ card.kicker }}</p>
        <h2>{{ card.title }}</h2>
        <p class="card__copy">{{ card.copy }}</p>
        <ul>
          <li v-for="point in card.points" :key="point">{{ point }}</li>
        </ul>
      </article>
    </section>
  </section>
</template>

<script>
export default {
  name: 'InsightsView',
  data() {
    return {
      cards: [
        {
          kicker: 'Health',
          title: 'Shell Integration',
          copy: 'Use this route to validate that hash navigation remains stable without interfering with the host app path.',
          points: [
            'The host URL should stay under /vue2-app.',
            'Only the hash fragment changes between child pages.',
            'Back and forward navigation should remain predictable.',
          ],
        },
        {
          kicker: 'Quality',
          title: 'Style Containment',
          copy: 'These cards create a different layout so you can test route transitions with more than one visual structure.',
          points: [
            'Scoped component styles stay local to the child app.',
            'Main app sidebar and shell spacing should not shift.',
            'Shared scroll behavior should match the host pages.',
          ],
        },
        {
          kicker: 'Plan',
          title: 'Next Steps',
          copy: 'Once routing is confirmed, the same structure can support real child pages like dashboards, settings, and reports.',
          points: [
            'Add dynamic routes for details pages.',
            'Introduce async page-level data loading.',
            'Add route guards only if the child app needs them.',
          ],
        },
      ],
    }
  },
}
</script>

<style scoped>
.insights-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hero {
  padding: 1.25rem;
  border-radius: 16px;
  background: linear-gradient(135deg, #f0faf5, #d9efe4);
}

.eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #2d7b5c;
}

.hero h1 {
  margin: 0;
}

.hero__copy {
  margin: 0.5rem 0 0;
  color: #52616f;
  max-width: 60ch;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.card {
  border: 1px solid #dbe7df;
  border-radius: 16px;
  background: #ffffff;
  padding: 1rem;
}

.card__kicker {
  margin: 0 0 0.35rem;
  color: #2d7b5c;
  font-size: 0.82rem;
}

.card h2 {
  margin: 0;
  font-size: 1.1rem;
}

.card__copy {
  margin: 0.5rem 0 0;
  color: #60707d;
}

.card ul {
  margin: 1rem 0 0;
  padding-left: 1.2rem;
}

.card li+li {
  margin-top: 0.55rem;
}
</style>
